// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";

export default class Organization {

    public id: string = "";

    public name: string = "";

    public vatId: string = "";

    public externalId: string | null = null;

    public favorite: boolean = false;

    public readonly isOrganization: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof Organization) || ((from as any).isOrganization === true));
    }

    public static as(from?: object | null): Organization | null {
        return (Organization.is(from)) ? from as Organization : null;
    }

    public static isNew(from?: Organization | string | null): boolean {
        return (
            (from == null) ||
            ((from === "") || (from === AthenaeumConstants.defaultGuid)) ||
            ((typeof from == "object") && (Organization.isNew(from.id)))
        );
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(Organization, "Organization");